import React from 'react';
import cx from 'classnames';

import SwitcherLayout from '../SwitcherLayout';

import stylesheet from './Modal.less';

export type ModalBodyProps = {
  children?: React.ReactNode;
  className?: string;
};

const ModalBody = ({ children, className, ...rest }: ModalBodyProps) => {
  return (
    <div className={cx(stylesheet.body, className)} {...rest}>
      <SwitcherLayout gap={0}>{children}</SwitcherLayout>
    </div>
  );
};

export default ModalBody;
